export class UserProfileConstants {
  public static readonly PROFILE_ATTRIBUTE_PRIVACYHINT = "privacyhint";
  public static readonly PROFILE_ATTRIBUTE_TERMS_AND_CONDITIONS = "termsAndConditions";
};
